// Retorna una lista de extensiones de archivos permitidos para LmUploadFiles (vue dropzone)
// Lista de MIME Types
// https://docs.w3cub.com/http/basics_of_http/mime_types/complete_list_of_mime_types
export const acceptedFilesGenerator = (extensions = []) => {
  if (Array.isArray(extensions) && extensions.length) {
    let accepted = []
    const extNames = extensions.map(e => e.name)
    for (const e of extNames) {
      switch (e.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
          accepted.push('image/jpeg')
          break
        case 'png':
          accepted.push('image/png')
          break
        case 'pdf':
          accepted.push('application/pdf')
          break
        case 'txt':
          accepted.push('text/plain')
          break
        case 'doc':
          accepted.push('application/msword')
          break
        case 'docx':
          accepted.push('.docx')
          break
        case 'ppt':
          accepted.push('application/vnd.ms-powerpoint')
          break
        case 'xls':
          accepted.push('application/vnd.ms-excel')
          break
        case 'xlsx':
          accepted.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          break
        case 'mp3':
          accepted.push('audio/mpeg')
          break
        case 'wav':
          accepted.push('audio/wav')
          break
        case 'mp4':
          accepted.push('video/mp4')
          break
        case 'mpeg':
          accepted.push('video/mpeg')
          break
        case 'rar':
          accepted.push('application/vnd.rar')
          break
        case 'zip':
          accepted.push('application/zip')
          break
        default:
          accepted.push(`.${e.toLowerCase()}`)
          break
      }
    }
    return accepted.join(',')
  } else {
    console.error('No se envió un Array o el mismo esta vacio.')
    return null
  }
}
